import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

// ─── Create a Stripe billing portal session for a company ───────────────────

interface BillingPortalPayload {
  /** ID of the company */
  company_id: string;
  /** API key of the company */
  company_api_key: string;
  /** URL to redirect back to after the portal session */
  return_url: string;
}

interface BillingPortalResponse {
  /** Stripe billing portal URL to redirect the user to */
  url: string;
}

/**
 * Create a Stripe billing portal session so the user can manage
 * payment methods, view invoices, update billing info, etc.
 */
export async function createBillingPortalSession(
  payload: BillingPortalPayload,
  auth: Authentication,
): Promise<BillingPortalResponse> {
  try {
    const response = await HttpClient.post(
      '/leedflow/stripe/billing-portal',
      {
        company_id: payload.company_id,
        return_url: payload.return_url,
      },
      auth.token,
      false,
      {
        'x-api-key': payload.company_api_key,
        'x-user-uid': auth.id,
      }
    );

    return response.data;
  } catch (e) {
    console.error('createBillingPortalSession error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new BillingPortalFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new BillingPortalFailure(e.message);
    }
    return Promise.reject(e);
  }
}

// ─── Failure class ───────────────────────────────────────────────────────────

export class BillingPortalFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

